import type { ComponentType, HTMLAttributes } from 'react'
import styled from 'styled-components'

export const SectionsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
` as ComponentType<HTMLAttributes<HTMLDivElement>>
